import { FormControl, FormGroup, Validators } from '@angular/forms';
import { customEmailValidator } from '../../validators/custom-email.validator';

export class LoginForm extends FormGroup {
  constructor() {
    super({
      email: new FormControl('', [Validators.required, customEmailValidator]),
      password: new FormControl(''),
      rememberMe: new FormControl(false),
      totp: new FormControl(''),
    });
  }

  get email(): FormControl {
    return this.get('email') as FormControl;
  }

  get password(): FormControl {
    return this.get('password') as FormControl;
  }

  get totp(): FormControl {
    return this.get('totp') as FormControl;
  }

  get rememberMe(): FormControl {
    return this.get('rememberMe') as FormControl;
  }
}
